import styled from "styled-components";
import {
  border,
  brand,
  radius,
  spacing,
  surface,
  text,
  typography,
} from "../../theme/tokens";

/**
 * Mobile bottom tab bar (Mobile DMS v1, Phase 1).
 *
 * Fixed to the bottom edge with iOS safe-area padding so the bar
 * clears the home indicator on notched phones. Height is content +
 * safe area; pages account for it via `MobilePageContent`'s
 * padding-bottom in `LayoutStyled.js`.
 */

// Content height of the bar, excluding the safe-area inset. Exported so
// the layout's bottom padding stays in lockstep with the bar.
export const TAB_BAR_HEIGHT_PX = 56;

export const TabBarWrapper = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1001;
  display: flex;
  align-items: stretch;
  height: calc(${TAB_BAR_HEIGHT_PX}px + env(safe-area-inset-bottom, 0px));
  padding-bottom: env(safe-area-inset-bottom, 0px);
  background: ${surface.surface};
  border-top: 1px solid ${border.light};
  box-sizing: border-box;
`;

export const TabButton = styled.button`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-width: 0;
  padding: ${spacing[1]} 0;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${({ $active }) => ($active ? brand.primary : text.muted)};
  -webkit-tap-highlight-color: transparent;

  &:focus-visible {
    outline: 2px solid ${brand.primary};
    outline-offset: -2px;
    border-radius: ${radius.md};
  }
`;

export const TabLabel = styled.span`
  font-size: ${typography.size.xs};
  font-weight: ${({ $active }) =>
    $active ? typography.weight.bold : typography.weight.medium};
  line-height: 1.2;
  white-space: nowrap;
`;

export const TabIconWrap = styled.span`
  position: relative;
  display: inline-flex;
`;

export const TabBadge = styled.span`
  position: absolute;
  top: -4px;
  right: -10px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: ${radius.pill};
  background: #c8201a;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  line-height: 16px;
  text-align: center;
  box-sizing: border-box;
  border: 1.5px solid ${surface.surface};
  pointer-events: none;
  user-select: none;
`;

// ---------------------------------------------------------------------------
// "More" sheet
// ---------------------------------------------------------------------------

export const MoreSheetList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MoreSheetItem = styled.button`
  display: flex;
  align-items: center;
  gap: ${spacing[3]};
  width: 100%;
  padding: ${spacing[3.5]} ${spacing[2]};
  background: transparent;
  border: none;
  border-bottom: 1px solid ${border.light};
  text-align: left;
  font-size: ${typography.size.md};
  font-weight: ${({ $active }) =>
    $active ? typography.weight.bold : typography.weight.medium};
  color: ${({ $active, $danger }) => {
    if ($danger) return "#A61412";
    return $active ? brand.primary : text.primary;
  }};
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &:last-child {
    border-bottom: none;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
